class InteractiveInput {
  constructor(data) {
    this.name = data.input.name
    this.placeholder = data.input.placeholder
    this.seekOffset = data.input.seekOffset
  }

  get type() {
    return 'input'
  }

  getHtmlOutput() {
    var html = '<input type="text" name="' + this.name +
      '" placeholder="' + this.placeholder + '" class="interactive-input"/>'
    return html;
  }
}

export { InteractiveInput }
